import React, { CSSProperties } from 'react';
import { CursorProps } from 'react-arborist';
import styled from 'styled-components';

export const ElementTreeDragCursor = React.memo(function DefaultCursor({ top, left, indent }: CursorProps) {
  const position: CSSProperties = {
    pointerEvents: 'none',
    position: 'absolute',
    top: top + 'px',
    left: left * 0.5833 + 3 + 'px',
    right: indent - 20 + 'px',
  };

  return (
    <Container style={{ ...position }}>
      <Pointer />
      <Line />
    </Container>
  );
});

const Container = styled.div`
  display: flex;
  z-index: 2;
`;

const Pointer = styled.div`
  width: 1px;
  height: 10px;
  translate: 0 -50%;
  background-color: var(--main-1);
`;

const Line = styled.div`
  flex: 1;
  height: 1px;
  border-top: 1px dashed var(--main-1);
  border-radius: 2px;
`;
